export default __webpack_public_path__ + "static/media/patient-on-bed-s-demo.ce92e8d8.png";